import axios from './axiosClient';
import { API_BASE_URL, API_URLS } from './constant';
import {
  filterProductsForStorefrontCatalog,
  isProductDisplayableOnStorefront,
} from '../utils/storefrontCatalogFilter';

export const getAllProducts = async (id, typeId, options = {}) => {
  const { signal } = options;
  const params = new URLSearchParams();
  params.append('catalogOnly', 'true');
  if (id && id !== 'undefined') {
    params.append('categoryId', id);
  }
  if (typeId && typeId !== 'undefined') {
    params.append('typeId', typeId);
  }
  const url = `${API_BASE_URL}${API_URLS.GET_PRODUCTS}?${params.toString()}`;

  try {
    const result = await axios(url, {
      method: 'GET',
      signal,
    });
    return filterProductsForStorefrontCatalog(result?.data);
  } catch (err) {
    if (axios.isCancel?.(err) || err.code === 'ERR_CANCELED') {
      throw err;
    }
    throw err;
  }
};

export const getProductBySlug = async (slug, options = {}) => {
  const { signal } = options;
  const q = new URLSearchParams({ slug: String(slug) });
  const url = `${API_BASE_URL}${API_URLS.GET_PRODUCTS}?${q.toString()}`;
  try {
    const result = await axios(url, {
      method: 'GET',
      signal,
    });
    const row = result?.data?.[0];
    return isProductDisplayableOnStorefront(row) ? row : undefined;
  } catch (err) {
    if (axios.isCancel?.(err) || err.code === 'ERR_CANCELED') {
      throw err;
    }
    return undefined;
  }
};
